<template>
  <el-busena :busena="hipotekaBusena" :color="busenaColor" :tooltip="tooltip" />
  <!-- <v-chip :color="busenaColor" small outlined class="mr-2" v-if="isBusena">
    {{ hipotekaBusena }}
  </v-chip> -->
</template>

<script>
import HipotekaMap from '../hipoteka/hipotekaMap'

export default {
  name: 'ElHipotekaBusena',
  props: {
    busena: String,
    tooltip: { type: String, default: null },
  },
  computed: {
    isBusena() {
      return this.busena
    },
    hipotekaBusena() {
      return this.isBusena && HipotekaMap['objektasBusena'][this.busena]
        ? `${HipotekaMap['objektasBusena'][this.busena].title}`
        : this.busena
    },
    busenaColor() {
      if (this.isBusenaIregistruotas) {
        return 'green'
      }
      if (this.isBusenaSuformuota) {
        return 'green'
      }
      if (this.isBusenaGrazintas) {
        return 'red'
      }
      if (this.isBusenaLaukiaPatvirtinimo) {
        return '#0a5c8e'
      }
      return 'default'
    },
    isBusenaAtmestas() {
      return this.busena === HipotekaMap['objektasBusena'].atmestas.key
    },
    isBusenaGrazintas() {
      return this.busena === HipotekaMap['objektasBusena'].grazintas.key
    },
    isBusenaIregistruotas() {
      return this.busena === HipotekaMap['objektasBusena'].iregistruotas.key
    },
    isBusenaLaukiaPatvirtinimo() {
      return (
        this.busena === HipotekaMap['objektasBusena'].laukia_patvirtinimo.key
      )
    },
    isBusenaSuformuota() {
      return this.busena === 'Suformuota'
    },
  },
}
</script>

<style lang="scss" scoped></style>
